import * as React from "react";

function SvgRounded2(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path className="rounded-2_svg__st2" d="M1609.5 133.2h-9.5c0-10.9-8.9-19.8-19.8-19.8H19.8C8.9 113.3 0 122.2 0 133.2l-10-.2v77h1619.5v-76.8z" /></svg>;
}

export default SvgRounded2;